import { render, staticRenderFns } from "./LactationDetails.vue?vue&type=template&id=7b0be5aa&scoped=true&"
import script from "./LactationDetails.vue?vue&type=script&lang=js&"
export * from "./LactationDetails.vue?vue&type=script&lang=js&"
import style0 from "./LactationDetails.vue?vue&type=style&index=0&id=7b0be5aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0be5aa",
  null
  
)

export default component.exports